import { useState } from "react";

const DS = {
  ink:"#0A0A0A",steel:"#2B5C8A",steelLt:"#4A80B5",
  steelFaint:"rgba(43,92,138,0.08)",steelFaint2:"rgba(43,92,138,0.14)",
  surface:"#F7F5F0",parchment:"#EFECE5",
  border:"rgba(26,26,26,0.13)",borderStrong:"rgba(26,26,26,0.26)",
  red:"#8B0000",noAffil:"#6B6B6B",
};

const STATUS_META = {
  signed:         { label:"Signed",         color:"#2B5C8A", bg:"rgba(43,92,138,0.10)",   tag:"A", icon:"◆" },
  proposed:       { label:"Proposed",       color:"#1a1a1a", bg:"rgba(26,26,26,0.07)",    tag:"B", icon:"◇" },
  no_affiliation: { label:"No Affiliation", color:"#6B6B6B", bg:"rgba(107,107,107,0.10)", tag:"C", icon:"○" },
  dont_recommend: { label:"Don't Rec.",     color:"#8B0000", bg:"rgba(139,0,0,0.08)",     tag:"D", icon:"✕" },
};

const INIT_COMPANIES = [
  { id:1,name:"NovaSport",  industry:"Fitness",     status:"signed",         relationship:"Paid Partnership",  logo:"💪",deal:"$24,000",     disclosure:"Paid Partnership",website:"novasport.com", notes:"Q3 renewal pending" },
  { id:2,name:"VitaCore",   industry:"Nutrition",   status:"signed",         relationship:"Affiliate Link",    logo:"🌿",deal:"$8,400",      disclosure:"Affiliate Link",  website:"vitacore.io",   notes:"15% commission" },
  { id:3,name:"FluxGear",   industry:"Apparel",     status:"proposed",       relationship:"Under Negotiation", logo:"🧢",deal:"$18K pending",disclosure:null,              website:"fluxgear.com",  notes:"Counter-offer sent" },
  { id:4,name:"PulseRoast", industry:"Coffee",      status:"proposed",       relationship:"Pitch Received",    logo:"☕",deal:"TBD",         disclosure:null,              website:"pulseroast.com",notes:"Call Jun 28" },
  { id:5,name:"ZenFlow",    industry:"Wellness",    status:"no_affiliation", relationship:"Independent Review",logo:"🧘",deal:null,          disclosure:"No Affiliation",  website:"zenflow.app",   notes:"Personal use only" },
  { id:6,name:"HyperFuel",  industry:"Supplements", status:"dont_recommend", relationship:"Rejected Offer",    logo:"⚡",deal:null,          disclosure:"Not Recommended", website:"hyperfuel.com", notes:"Poor ingredient quality" },
  { id:7,name:"ArcThread",  industry:"Apparel",     status:"signed",         relationship:"Gifted Product",    logo:"🧵",deal:"Gifted",      disclosure:"Gifted Product",  website:"arcthread.co",  notes:"Seasonal gifting" },
  { id:8,name:"LumenLab",   industry:"Tech",        status:"proposed",       relationship:"Deal in Review",    logo:"💡",deal:"$31K pending",disclosure:null,              website:"lumenlab.io",   notes:"Legal review" },
];

const ADS = [
  { id:1,companyId:1,title:"Summer Performance Campaign",copy:"Push your limits with NovaSport's latest compression line. Built for athletes who refuse to stop.",goal:"Brand Awareness",media:"🎬",deadline:"Jun 30" },
  { id:2,companyId:2,title:"30-Day Transformation Challenge",copy:"VitaCore protein blend — no fillers, no fluff. Real results for real athletes.",goal:"Conversions",media:"📸",deadline:"Jul 15" },
  { id:3,companyId:7,title:"ArcThread Drop 002",copy:"New colorway. Limited run. Performance meets street.",goal:"Product Launch",media:"🎬",deadline:"Jun 22" },
];

const INIT_COMMENTS = {
  1:[
    { id:1,friend:"Dani K.",   text:"The ad hits hard, the music choice is fire. I'd definitely click.",wouldBuy:true, stars:5,time:"2h ago" },
    { id:2,friend:"Marcus L.", text:"Felt a bit long at the 30-second mark. Cut it tighter and it's perfect.",wouldBuy:true, stars:3,time:"5h ago" },
    { id:3,friend:"Yara P.",   text:"Love the visuals but the CTA button color doesn't pop on mobile.",wouldBuy:false,stars:4,time:"1d ago" },
  ],
  2:[
    { id:4,friend:"Tayo R.",   text:"The before/after shots are compelling. I'd share this.",wouldBuy:true, stars:5,time:"3h ago" },
    { id:5,friend:"Sam B.",    text:"The price feels hidden in the copy. Lead with the offer.",wouldBuy:false,stars:4,time:"8h ago" },
  ],
  3:[
    { id:6,friend:"Nia F.",    text:"Clean, minimal, exactly what ArcThread needs. Would wear this.",wouldBuy:true, stars:5,time:"1h ago" },
  ],
};

const FRIENDS = [
  { id:1,handle:"@danikfit",    name:"Dani K.",   avatar:"🧡",followers:"128K",following:"412",posts:284, bio:"NASM-CPT · Strength & mobility coach · Chicago 🏙️",verified:true, category:"Fitness",   grid:["🏋️","🥗","👟","💪","🧘","🏃","🥤","🎽","🔥"],mutualBrands:["NovaSport","ArcThread"] },
  { id:2,handle:"@marcuslifts", name:"Marcus L.", avatar:"💙",followers:"54.2K",following:"889",posts:612,bio:"Powerlifting & nutrition. No fluff, just reps. LA 🌴",verified:false,category:"Strength", grid:["🏋️","📊","🥩","⚡","🛏️","🧲","🔩","📈","💊"],mutualBrands:["VitaCore"] },
  { id:3,handle:"@yarawellness",name:"Yara P.",   avatar:"💚",followers:"203K",following:"560",posts:1041,bio:"Holistic health · mindfulness · EB + running 🌿",verified:true, category:"Wellness",  grid:["🧘","🍃","🌅","🫖","🌸","🏃","📖","🫁","✨"],mutualBrands:["ZenFlow","VitaCore"] },
  { id:4,handle:"@tayorunz",    name:"Tayo R.",   avatar:"🔥",followers:"87.6K",following:"234",posts:439,bio:"Marathon runner · plant-based athlete · NYC 🗽",verified:false,category:"Endurance", grid:["🏃","🌿","🗺️","👟","⏱️","🌧️","🎽","💧","🏅"],mutualBrands:["VitaCore","NovaSport"] },
  { id:5,handle:"@sambefit",    name:"Sam B.",    avatar:"🌊",followers:"31.8K",following:"702",posts:198,bio:"CrossFit L2 · kettlebells · coffee addict ☕",verified:false,category:"CrossFit",  grid:["⚙️","🏋️","☕","💦","🎯","🔥","📸","🤸","🥊"],mutualBrands:["PulseRoast"] },
  { id:6,handle:"@niathread",   name:"Nia F.",    avatar:"🪩",followers:"166K",following:"318",posts:876,bio:"Style + sweat · fashion & fitness culture · ATL 🍑",verified:true, category:"Lifestyle", grid:["👗","🏃","🪞","🧵","✂️","🌆","👟","📸","🎨"],mutualBrands:["ArcThread","FluxGear"] },
];

const DISCLOSURE_OPTIONS = ["Paid Partnership","Affiliate Link","Gifted Product","Investor Relationship","No Affiliation","Not Recommended"];
const INDUSTRY_OPTIONS   = ["Fitness","Nutrition","Apparel","Coffee","Wellness","Supplements","Tech","Beauty","Finance","Travel","Other"];
const LOGO_OPTIONS       = ["💪","🌿","🧢","☕","🧘","⚡","🧵","💡","🏃","🎽","💊","🔥","🌊","👟","📱","🎯","⚙️","🌸"];

/* ─── CSS ─── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;600;700&family=EB+Garamond:wght@400;500&family=Bebas+Neue&family=DM+Mono:wght@400;500&display=swap');
  *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
  body{background:#EFECE5;font-family:'EB Garamond',Georgia,serif;color:#0A0A0A;-webkit-font-smoothing:antialiased}
  ::-webkit-scrollbar{width:3px}::-webkit-scrollbar-track{background:#EFECE5}::-webkit-scrollbar-thumb{background:rgba(26,26,26,0.13);border-radius:2px}
  .fz-app{max-width:430px;margin:0 auto;min-height:100svh;background:#EFECE5;display:flex;flex-direction:column}
  .fz-nav{position:fixed;bottom:0;left:50%;transform:translateX(-50%);width:100%;max-width:430px;height:56px;background:#0A0A0A;display:flex;align-items:stretch;z-index:200;border-top:1px solid rgba(255,255,255,0.08)}
  .fz-nav-btn{flex:1;background:transparent;border:none;cursor:pointer;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:3px;min-height:44px;transition:background 0.15s}
  .fz-nav-btn:hover{background:rgba(255,255,255,0.04)}
  .fz-nav-btn.active{background:rgba(43,92,138,0.18);border-top:2px solid #2B5C8A}
  .fz-nav-icon{font-size:16px;line-height:1}
  .fz-nav-label{font-family:'DM Mono',monospace;font-size:8.5px;letter-spacing:0.08em;color:rgba(255,255,255,0.45);text-transform:uppercase}
  .fz-nav-btn.active .fz-nav-label{color:#4A80B5}
  .fz-header{background:#0A0A0A;padding:16px 20px 14px;display:flex;align-items:center;justify-content:space-between;position:sticky;top:0;z-index:100}
  .fz-wordmark{font-family:'Cormorant Garamond',serif;font-size:20px;font-weight:700;color:#fff;letter-spacing:0.02em}
  .fz-wordmark span{color:#4A80B5}
  .fz-scroll{flex:1;overflow-y:auto;padding-bottom:72px;-webkit-overflow-scrolling:touch}
  .fz-card{background:#F7F5F0;border-radius:3px;border:1px solid rgba(26,26,26,0.13);border-top:3px solid #2B5C8A}
  .fz-card-red{border-top-color:#8B0000}.fz-card-ink{border-top-color:#0A0A0A}.fz-card-grey{border-top-color:#6B6B6B}
  .fz-pill{display:inline-flex;align-items:center;gap:5px;padding:2px 9px;border-radius:2px;font-family:'DM Mono',monospace;font-size:9px;letter-spacing:0.06em;font-weight:500;text-transform:uppercase;border:1px solid currentColor}
  .fz-tabs{display:flex;overflow-x:auto;padding:0 20px;border-bottom:1px solid rgba(26,26,26,0.13);background:#F7F5F0;scrollbar-width:none}
  .fz-tabs::-webkit-scrollbar{display:none}
  .fz-tab{flex-shrink:0;background:transparent;border:none;border-bottom:2px solid transparent;padding:12px 14px;font-family:'DM Mono',monospace;font-size:10px;letter-spacing:0.07em;text-transform:uppercase;color:#6B6B6B;cursor:pointer;min-height:44px;display:flex;align-items:center;gap:5px;transition:all 0.15s;white-space:nowrap}
  .fz-tab.active{color:#2B5C8A;border-bottom-color:#2B5C8A}
  .fz-tab-count{background:rgba(43,92,138,0.08);color:#2B5C8A;padding:1px 5px;border-radius:2px;font-size:9px}
  .fz-tab.active .fz-tab-count{background:#2B5C8A;color:#fff}
  .fz-stat-grid{display:grid;grid-template-columns:1fr 1fr;gap:1px;background:rgba(26,26,26,0.13);border-radius:3px;overflow:hidden;border:1px solid rgba(26,26,26,0.13)}
  .fz-stat-tile{background:#F7F5F0;padding:16px 18px;cursor:pointer;transition:background 0.15s}
  .fz-stat-tile:hover{background:rgba(43,92,138,0.08)}
  .fz-stat-num{font-family:'Bebas Neue',sans-serif;font-size:40px;line-height:1;letter-spacing:0.02em}
  .fz-stat-label{font-family:'DM Mono',monospace;font-size:9px;letter-spacing:0.09em;text-transform:uppercase;margin-top:4px}
  .fz-row{display:flex;align-items:center;gap:14px;padding:14px 20px;background:#F7F5F0;border-bottom:1px solid rgba(26,26,26,0.13);cursor:pointer;min-height:64px;transition:background 0.12s}
  .fz-row:hover{background:rgba(43,92,138,0.08)}.fz-row:last-child{border-bottom:none}
  .fz-logo{width:40px;height:40px;border-radius:3px;display:flex;align-items:center;justify-content:center;font-size:20px;flex-shrink:0;border:1px solid rgba(26,26,26,0.13);background:#EFECE5}
  .fz-back{background:#F7F5F0;border:none;font-family:'DM Mono',monospace;font-size:10px;letter-spacing:0.07em;text-transform:uppercase;color:#2B5C8A;cursor:pointer;display:flex;align-items:center;gap:6px;padding:14px 20px;min-height:44px;border-bottom:1px solid rgba(26,26,26,0.13);width:100%;transition:background 0.12s}
  .fz-back:hover{background:rgba(43,92,138,0.08)}
  .fz-shd{font-family:'DM Mono',monospace;font-size:9px;letter-spacing:0.12em;text-transform:uppercase;color:#6B6B6B;padding:14px 20px 8px}
  .fz-dr{display:flex;justify-content:space-between;align-items:center;padding:9px 20px;border-bottom:1px solid rgba(26,26,26,0.13);min-height:44px}
  .fz-dr:last-child{border-bottom:none}
  .fz-dk{font-family:'DM Mono',monospace;font-size:10px;letter-spacing:0.06em;color:#6B6B6B}
  .fz-dv{font-family:'EB Garamond',serif;font-size:15px;color:#0A0A0A;text-align:right;max-width:60%}
  .fz-ad-card{background:#F7F5F0;border-radius:3px;border:1px solid rgba(26,26,26,0.13);border-top:3px solid #2B5C8A;cursor:pointer;transition:box-shadow 0.15s}
  .fz-ad-card:hover{box-shadow:0 2px 12px rgba(43,92,138,0.12)}
  .fz-comment{background:#F7F5F0;border-radius:3px;border:1px solid rgba(26,26,26,0.13);border-left:3px solid rgba(26,26,26,0.13);padding:14px 16px;transition:border-left-color 0.2s}
  .fz-comment.starred{border-left-color:#2B5C8A}.fz-comment.top-rated{border-left-color:#0A0A0A}
  .fz-stars{display:flex;gap:2px;align-items:center}
  .fz-star{font-size:16px;cursor:pointer;color:rgba(26,26,26,0.13);transition:color 0.1s,transform 0.1s;line-height:1;user-select:none;-webkit-user-select:none}
  .fz-star.on{color:#2B5C8A}.fz-star:hover{transform:scale(1.2)}
  .fz-star.ro{cursor:default;font-size:13px}.fz-star.ro:hover{transform:none}
  .fz-textarea{width:100%;background:#EFECE5;border:1px solid rgba(26,26,26,0.26);border-radius:2px;padding:12px 14px;font-family:'EB Garamond',serif;font-size:16px;color:#0A0A0A;resize:none;outline:none;min-height:88px;transition:border-color 0.15s}
  .fz-textarea:focus{border-color:#2B5C8A}
  .fz-textarea::placeholder{color:rgba(10,10,10,0.35)}
  .fz-inp{width:100%;background:#EFECE5;border:1px solid rgba(26,26,26,0.26);border-radius:2px;padding:0 14px;font-family:'EB Garamond',serif;font-size:16px;color:#0A0A0A;outline:none;height:44px;transition:border-color 0.15s}
  .fz-inp:focus{border-color:#2B5C8A}.fz-inp::placeholder{color:rgba(10,10,10,0.35)}
  .fz-sel{width:100%;background:#EFECE5;border:1px solid rgba(26,26,26,0.26);border-radius:2px;padding:0 14px;font-family:'DM Mono',monospace;font-size:13px;color:#0A0A0A;outline:none;height:44px;cursor:pointer;appearance:none;-webkit-appearance:none}
  .fz-sel:focus{border-color:#2B5C8A}
  .fz-lbl{font-family:'DM Mono',monospace;font-size:9px;letter-spacing:0.1em;text-transform:uppercase;color:#6B6B6B;display:block;margin-bottom:6px}
  .fz-btn-p{background:#0A0A0A;color:#fff;border:none;border-radius:2px;font-family:'DM Mono',monospace;font-size:11px;letter-spacing:0.08em;text-transform:uppercase;padding:0 20px;height:44px;cursor:pointer;transition:background 0.15s;white-space:nowrap}
  .fz-btn-p:hover{background:#2B5C8A}
  .fz-btn-d{background:transparent;color:#8B0000;border:1px solid rgba(139,0,0,0.35);border-radius:2px;font-family:'DM Mono',monospace;font-size:11px;letter-spacing:0.08em;text-transform:uppercase;padding:0 16px;height:44px;cursor:pointer;transition:all 0.15s}
  .fz-btn-d:hover{background:rgba(139,0,0,0.08);border-color:#8B0000}
  .fz-btn-g{background:transparent;color:#0A0A0A;border:1px solid rgba(26,26,26,0.26);border-radius:2px;font-family:'DM Mono',monospace;font-size:11px;letter-spacing:0.08em;text-transform:uppercase;padding:0 16px;height:44px;cursor:pointer;transition:all 0.15s}
  .fz-btn-g:hover{border-color:#0A0A0A;background:rgba(10,10,10,0.04)}
  .fz-btn-t{background:transparent;border:1px solid rgba(26,26,26,0.26);border-radius:2px;font-family:'DM Mono',monospace;font-size:10px;letter-spacing:0.06em;text-transform:uppercase;padding:0 14px;height:36px;cursor:pointer;color:#6B6B6B;transition:all 0.15s;min-width:44px}
  .fz-btn-t.ay{background:rgba(43,92,138,0.12);border-color:#2B5C8A;color:#2B5C8A}
  .fz-btn-t.an{background:rgba(139,0,0,0.08);border-color:#8B0000;color:#8B0000}
  .fz-btn-s{background:transparent;border:1px solid rgba(26,26,26,0.13);border-radius:2px;font-family:'DM Mono',monospace;font-size:9px;letter-spacing:0.07em;text-transform:uppercase;padding:0 10px;height:32px;cursor:pointer;color:#6B6B6B;transition:all 0.15s}
  .fz-btn-s.active{background:rgba(43,92,138,0.14);border-color:#2B5C8A;color:#2B5C8A}
  .fz-btn-i{background:transparent;border:none;cursor:pointer;padding:8px;min-width:44px;min-height:44px;display:flex;align-items:center;justify-content:center;border-radius:2px;transition:background 0.12s;font-size:16px}
  .fz-btn-i:hover{background:rgba(43,92,138,0.08)}
  .fz-fab{position:fixed;bottom:68px;right:calc(50% - 215px + 16px);width:52px;height:52px;background:#0A0A0A;border:none;border-radius:3px;cursor:pointer;display:flex;align-items:center;justify-content:center;font-size:24px;color:#fff;z-index:150;box-shadow:0 4px 16px rgba(10,10,10,0.25);transition:background 0.15s}
  .fz-fab:hover{background:#2B5C8A}
  @media(max-width:430px){.fz-fab{right:16px}}
  .fz-overlay{position:fixed;inset:0;background:rgba(10,10,10,0.65);z-index:300;display:flex;align-items:flex-end;justify-content:center}
  .fz-modal{background:#F7F5F0;width:100%;max-width:430px;max-height:92svh;border-radius:3px 3px 0 0;border-top:3px solid #2B5C8A;display:flex;flex-direction:column;overflow:hidden}
  .fz-modal-hd{display:flex;align-items:center;justify-content:space-between;padding:16px 20px;border-bottom:1px solid rgba(26,26,26,0.13);flex-shrink:0}
  .fz-modal-bd{overflow-y:auto;padding:20px;display:flex;flex-direction:column;gap:16px;flex:1}
  .fz-modal-ft{padding:16px 20px;border-top:1px solid rgba(26,26,26,0.13);display:flex;gap:10px;flex-shrink:0}
  .fz-confirm-box{background:#F7F5F0;width:calc(100% - 40px);max-width:390px;border-radius:3px;border-top:3px solid #8B0000;padding:24px 20px 20px}
  .fz-metrics{display:flex;border-top:1px solid rgba(26,26,26,0.13)}
  .fz-met{flex:1;padding:12px;text-align:center;border-right:1px solid rgba(26,26,26,0.13)}
  .fz-met:last-child{border-right:none}
  .fz-met-n{font-family:'Bebas Neue',sans-serif;font-size:26px;line-height:1;letter-spacing:0.03em}
  .fz-met-l{font-family:'DM Mono',monospace;font-size:8px;letter-spacing:0.09em;text-transform:uppercase;color:#6B6B6B;margin-top:3px}
  .fz-role{font-family:'DM Mono',monospace;font-size:9px;letter-spacing:0.07em;text-transform:uppercase;padding:5px 10px;border-radius:2px;border:1px solid rgba(255,255,255,0.18);color:rgba(255,255,255,0.6);cursor:pointer;background:transparent;transition:all 0.15s;min-height:32px}
  .fz-role:hover{border-color:#4A80B5;color:#4A80B5}
  .fz-avatar{width:72px;height:72px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:32px;flex-shrink:0;border:2px solid #2B5C8A;background:#EFECE5}
  .fz-ig-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:2px}
  .fz-ig-cell{aspect-ratio:1;background:#EFECE5;border:1px solid rgba(26,26,26,0.13);display:flex;align-items:center;justify-content:center;font-size:28px;border-radius:2px;cursor:pointer;transition:background 0.12s}
  .fz-ig-cell:hover{background:rgba(43,92,138,0.08)}
  .fz-fc{background:#F7F5F0;border:1px solid rgba(26,26,26,0.13);border-top:3px solid #2B5C8A;border-radius:3px;overflow:hidden;cursor:pointer;transition:box-shadow 0.15s}
  .fz-fc:hover{box-shadow:0 2px 12px rgba(43,92,138,0.10)}
  .fz-vbadge{display:inline-flex;align-items:center;justify-content:center;width:13px;height:13px;background:#2B5C8A;border-radius:50%;font-size:7px;color:#fff;margin-left:4px;flex-shrink:0}
  .fz-logo-grid{display:grid;grid-template-columns:repeat(6,1fr);gap:6px}
  .fz-logo-opt{height:40px;font-size:20px;border:1px solid rgba(26,26,26,0.13);border-radius:2px;background:#EFECE5;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:all 0.12s}
  .fz-logo-opt.sel{border-color:#2B5C8A;background:rgba(43,92,138,0.08)}
  .fz-logo-opt:hover{border-color:#2B5C8A}
  @keyframes fadeSlide{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}
  .fs{animation:fadeSlide 0.25s ease both}
  @keyframes slideUp{from{transform:translateY(100%);opacity:0.7}to{transform:translateY(0);opacity:1}}
  .su{animation:slideUp 0.28s cubic-bezier(0.32,0.72,0,1) both}
`;

/* ─── Small components ─── */
const Pill = ({ status }) => {
  const m = STATUS_META[status]; if (!m) return null;
  return <span className="fz-pill" style={{ color:m.color,borderColor:m.color,backgroundColor:m.bg }}><span style={{fontSize:7}}>{m.icon}</span>{m.label}</span>;
};
const BTag = ({ status }) => {
  const m = STATUS_META[status];
  return <span style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:18,color:m?.color,lineHeight:1}}>{m?.tag}</span>;
};
const Stars = ({ count, onRate, ro }) => (
  <div className="fz-stars">
    {[1,2,3,4,5].map(i => (
      <span key={i} className={`fz-star${i<=count?" on":""}${ro?" ro":""}`} onClick={() => !ro && onRate?.(i)}>★</span>
    ))}
  </div>
);
const FF = ({ label, children }) => <div><label className="fz-lbl">{label}</label>{children}</div>;
const Sel = ({ value, onChange, children }) => (
  <div style={{position:"relative"}}>
    <select className="fz-sel" value={value} onChange={onChange}>{children}</select>
    <span style={{position:"absolute",right:12,top:"50%",transform:"translateY(-50%)",pointerEvents:"none",fontSize:10,color:"#6B6B6B"}}>▾</span>
  </div>
);

/* ─── Company CRUD Modal ─── */
const BLANK = { name:"",industry:"Fitness",status:"proposed",relationship:"",logo:"💪",deal:"",disclosure:"",website:"",notes:"" };

function CompanyModal({ company, onSave, onDelete, onClose }) {
  const isEdit = !!company?.id;
  const [f, setF] = useState(company || BLANK);
  const [del, setDel] = useState(false);
  const set = (k,v) => setF(p => ({...p,[k]:v}));

  if (del) return (
    <div className="fz-overlay" onClick={() => setDel(false)}>
      <div className="fz-confirm-box" onClick={e => e.stopPropagation()}>
        <div style={{fontFamily:"'Cormorant Garamond',serif",fontSize:20,fontWeight:700,marginBottom:8}}>Delete {f.name}?</div>
        <div style={{fontFamily:"'EB Garamond',serif",fontSize:14,color:"#6B6B6B",marginBottom:20,lineHeight:1.6}}>This will permanently remove the brand and all associated data.</div>
        <div style={{display:"flex",gap:10}}>
          <button className="fz-btn-g" style={{flex:1}} onClick={() => setDel(false)}>Cancel</button>
          <button className="fz-btn-d" style={{flex:1}} onClick={() => onDelete(f.id)}>Delete</button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="fz-overlay" onClick={onClose}>
      <div className="fz-modal su" onClick={e => e.stopPropagation()}>
        <div className="fz-modal-hd">
          <div style={{fontFamily:"'Cormorant Garamond',serif",fontSize:18,fontWeight:700}}>{isEdit?`Edit ${f.name}`:"Add Brand"}</div>
          <button className="fz-btn-i" onClick={onClose}>✕</button>
        </div>
        <div className="fz-modal-bd">
          <FF label="Logo">
            <div className="fz-logo-grid">
              {LOGO_OPTIONS.map(e => <button key={e} className={`fz-logo-opt${f.logo===e?" sel":""}`} onClick={()=>set("logo",e)}>{e}</button>)}
            </div>
          </FF>
          <FF label="Brand Name"><input className="fz-inp" value={f.name} onChange={e=>set("name",e.target.value)} placeholder="e.g. NovaSport" /></FF>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
            <FF label="Industry">
              <Sel value={f.industry} onChange={e=>set("industry",e.target.value)}>
                {INDUSTRY_OPTIONS.map(o=><option key={o}>{o}</option>)}
              </Sel>
            </FF>
            <FF label="Status">
              <Sel value={f.status} onChange={e=>set("status",e.target.value)}>
                {Object.entries(STATUS_META).map(([k,m])=><option key={k} value={k}>{m.label}</option>)}
              </Sel>
            </FF>
          </div>
          <FF label="Relationship Type"><input className="fz-inp" value={f.relationship} onChange={e=>set("relationship",e.target.value)} placeholder="e.g. Paid Partnership" /></FF>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
            <FF label="Deal Value"><input className="fz-inp" value={f.deal} onChange={e=>set("deal",e.target.value)} placeholder="e.g. $12,000" /></FF>
            <FF label="Website"><input className="fz-inp" value={f.website} onChange={e=>set("website",e.target.value)} placeholder="brand.com" /></FF>
          </div>
          <FF label="Disclosure">
            <Sel value={f.disclosure||""} onChange={e=>set("disclosure",e.target.value)}>
              <option value="">None</option>
              {DISCLOSURE_OPTIONS.map(o=><option key={o}>{o}</option>)}
            </Sel>
          </FF>
          <FF label="Private Notes">
            <textarea className="fz-textarea" value={f.notes} onChange={e=>set("notes",e.target.value)} placeholder="Internal notes, deal terms, follow-ups…" rows={3} style={{minHeight:70}} />
          </FF>
        </div>
        <div className="fz-modal-ft">
          {isEdit && <button className="fz-btn-d" onClick={()=>setDel(true)}>Delete</button>}
          <button className="fz-btn-g" style={{flex:1}} onClick={onClose}>Cancel</button>
          <button className="fz-btn-p" style={{flex:2,opacity:f.name.trim()?1:0.45}} onClick={()=>f.name.trim()&&onSave(f)}>
            {isEdit?"Save Changes":"Add Brand"}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ─── Friend Profile Modal ─── */
function FriendModal({ friend, companies, onClose }) {
  return (
    <div className="fz-overlay" onClick={onClose}>
      <div className="fz-modal su" onClick={e=>e.stopPropagation()}>
        <div className="fz-modal-hd">
          <div style={{fontFamily:"'DM Mono',monospace",fontSize:10,letterSpacing:"0.08em",color:"#6B6B6B",textTransform:"uppercase"}}>Friend Profile</div>
          <button className="fz-btn-i" onClick={onClose}>✕</button>
        </div>
        <div className="fz-modal-bd" style={{gap:20}}>
          {/* IG header */}
          <div style={{display:"flex",alignItems:"center",gap:16}}>
            <div className="fz-avatar">{friend.avatar}</div>
            <div style={{flex:1}}>
              <div style={{display:"flex",alignItems:"center",gap:4,marginBottom:2}}>
                <div style={{fontFamily:"'DM Mono',monospace",fontSize:14,fontWeight:500}}>{friend.handle}</div>
                {friend.verified && <span className="fz-vbadge">✓</span>}
              </div>
              <div style={{fontFamily:"'Cormorant Garamond',serif",fontSize:17,fontWeight:700}}>{friend.name}</div>
              <div style={{fontFamily:"'DM Mono',monospace",fontSize:9,letterSpacing:"0.06em",color:"#2B5C8A",textTransform:"uppercase",marginTop:2}}>{friend.category}</div>
            </div>
          </div>
          {/* Stats */}
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",border:"1px solid rgba(26,26,26,0.13)",borderRadius:3,overflow:"hidden",background:"#F7F5F0"}}>
            {[["Posts",friend.posts],["Followers",friend.followers],["Following",friend.following]].map(([l,v])=>(
              <div key={l} style={{padding:"12px 8px",textAlign:"center",borderRight:"1px solid rgba(26,26,26,0.13)"}}>
                <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:22}}>{v}</div>
                <div style={{fontFamily:"'DM Mono',monospace",fontSize:8,letterSpacing:"0.09em",color:"#6B6B6B",textTransform:"uppercase",marginTop:2}}>{l}</div>
              </div>
            ))}
          </div>
          {/* Bio */}
          <div style={{fontFamily:"'EB Garamond',serif",fontSize:15,lineHeight:1.65,padding:"12px 14px",background:"#F7F5F0",border:"1px solid rgba(26,26,26,0.13)",borderRadius:3}}>{friend.bio}</div>
          {/* Mutual brands */}
          {friend.mutualBrands?.length>0 && (
            <div>
              <div className="fz-shd" style={{padding:"0 0 8px"}}>Mutual Brand Interest</div>
              <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
                {friend.mutualBrands.map(b=>{
                  const co=companies.find(c=>c.name===b);
                  return co?<span key={b} style={{display:"inline-flex",alignItems:"center",gap:5,padding:"4px 10px",background:"#F7F5F0",border:"1px solid rgba(26,26,26,0.13)",borderRadius:2,fontFamily:"'DM Mono',monospace",fontSize:10}}><span>{co.logo}</span>{b}</span>:null;
                })}
              </div>
            </div>
          )}
          {/* Grid */}
          <div>
            <div className="fz-shd" style={{padding:"0 0 8px"}}>Posts</div>
            <div className="fz-ig-grid">
              {friend.grid.map((e,i)=><div key={i} className="fz-ig-cell">{e}</div>)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ─── MAIN ─── */
export default function FriendstaZone() {
  const [tab, setTab]                     = useState("home");
  const [brandFilter, setBrandFilter]     = useState("all");
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [selectedAd, setSelectedAd]       = useState(null);
  const [selectedFriend, setSelectedFriend] = useState(null);
  const [companies, setCompanies]         = useState(INIT_COMPANIES);
  const [comments, setComments]           = useState(INIT_COMMENTS);
  const [csort, setCsort]                 = useState("stars");
  const [draft, setDraft]                 = useState({ text:"", wouldBuy:true });
  const [role, setRole]                   = useState("influencer");
  const [cModal, setCModal]               = useState(null);
  const [searchQ, setSearchQ]             = useState("");

  const counts = {
    all:companies.length,
    signed:companies.filter(c=>c.status==="signed").length,
    proposed:companies.filter(c=>c.status==="proposed").length,
    no_affiliation:companies.filter(c=>c.status==="no_affiliation").length,
    dont_recommend:companies.filter(c=>c.status==="dont_recommend").length,
  };

  const filtered = companies
    .filter(c => brandFilter==="all"||c.status===brandFilter)
    .filter(c => !searchQ||c.name.toLowerCase().includes(searchQ.toLowerCase())||c.industry.toLowerCase().includes(searchQ.toLowerCase()));

  const topClass = s => s==="dont_recommend"?"fz-card fz-card-red":s==="proposed"?"fz-card fz-card-ink":s==="no_affiliation"?"fz-card fz-card-grey":"fz-card";

  const saveCompany = form => {
    if (form.id) { setCompanies(p=>p.map(c=>c.id===form.id?form:c)); setSelectedBrand(form); }
    else { const nc={...form,id:Date.now()}; setCompanies(p=>[...p,nc]); }
    setCModal(null);
  };
  const deleteCompany = id => { setCompanies(p=>p.filter(c=>c.id!==id)); setSelectedBrand(null); setCModal(null); };

  const getSorted = id => {
    const raw=comments[id]||[];
    return [...raw].sort((a,b)=>csort==="stars"?b.stars-a.stars:b.id-a.id);
  };
  const postComment = id => {
    if(!draft.text.trim()) return;
    setComments(p=>({...p,[id]:[...(p[id]||[]),{id:Date.now(),friend:role==="influencer"?"You (Influencer)":"You",text:draft.text,wouldBuy:draft.wouldBuy,stars:0,time:"just now"}]}));
    setDraft({text:"",wouldBuy:true});
  };
  const rateC = (adId,cmId,s) => {
    if(role!=="influencer") return;
    setComments(p=>({...p,[adId]:p[adId].map(c=>c.id===cmId?{...c,stars:s}:c)}));
  };

  /* HOME */
  const HomeView = () => (
    <div className="fs">
      <div style={{padding:"28px 20px 20px",background:"#F7F5F0",borderBottom:"1px solid rgba(26,26,26,0.13)"}}>
        <div style={{fontFamily:"'Cormorant Garamond',serif",fontSize:28,fontWeight:700,lineHeight:1.1,letterSpacing:"0.01em"}}>Endorsement<br/><span style={{color:"#2B5C8A"}}>Intel.</span></div>
        <div style={{fontFamily:"'EB Garamond',serif",fontSize:14,color:"#6B6B6B",marginTop:8}}>Know who they sign. Know who they avoid.</div>
      </div>
      <div style={{padding:"20px 20px 0"}}>
        <div className="fz-shd" style={{padding:"0 0 8px"}}>Status Breakdown</div>
        <div className="fz-stat-grid" style={{marginBottom:24}}>
          {[{key:"signed",label:"Signed",color:"#2B5C8A"},{key:"proposed",label:"Proposed",color:"#1a1a1a"},{key:"no_affiliation",label:"No Affil.",color:"#6B6B6B"},{key:"dont_recommend",label:"Don't Rec.",color:"#8B0000"}].map(s=>(
            <div key={s.key} className="fz-stat-tile" onClick={()=>{setBrandFilter(s.key);setTab("brands")}}>
              <div className="fz-stat-num" style={{color:s.color}}>{counts[s.key]}</div>
              <div className="fz-stat-label" style={{color:s.color}}>{s.label}</div>
            </div>
          ))}
        </div>
        <div className="fz-shd" style={{padding:"0 0 8px"}}>Active Deals</div>
        <div className={topClass("signed")} style={{marginBottom:24}}>
          {companies.filter(c=>c.status==="signed").map(c=>(
            <div key={c.id} className="fz-row" onClick={()=>{setSelectedBrand(c);setTab("brands")}}>
              <div className="fz-logo">{c.logo}</div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontFamily:"'Cormorant Garamond',serif",fontSize:16,fontWeight:700}}>{c.name}</div>
                <div style={{fontFamily:"'DM Mono',monospace",fontSize:9,letterSpacing:"0.05em",color:"#6B6B6B",marginTop:2}}>{c.industry} · {c.disclosure}</div>
              </div>
              <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:15,color:"#2B5C8A",flexShrink:0}}>{c.deal}</div>
            </div>
          ))}
          {!companies.filter(c=>c.status==="signed").length&&<div style={{padding:20,fontFamily:"'EB Garamond',serif",fontSize:14,color:"#6B6B6B",textAlign:"center"}}>No signed deals yet.</div>}
        </div>
        <div className="fz-shd" style={{padding:"0 0 8px"}}>Live Ad Rooms</div>
        <div style={{display:"flex",flexDirection:"column",gap:10,marginBottom:20}}>
          {ADS.map(ad=>{
            const co=companies.find(c=>c.id===ad.companyId);
            const cnt=(comments[ad.id]||[]).length;
            const avg=cnt?((comments[ad.id]||[]).reduce((s,c)=>s+c.stars,0)/cnt).toFixed(1):"—";
            return (
              <div key={ad.id} className="fz-ad-card" onClick={()=>{setSelectedAd(ad);setTab("adroom")}}>
                <div style={{display:"flex",alignItems:"center",gap:12,padding:"14px 16px"}}>
                  <span style={{fontSize:22,flexShrink:0}}>{ad.media}</span>
                  <div style={{flex:1}}>
                    <div style={{fontFamily:"'Cormorant Garamond',serif",fontSize:15,fontWeight:700}}>{ad.title}</div>
                    <div style={{fontFamily:"'DM Mono',monospace",fontSize:9,letterSpacing:"0.06em",color:"#6B6B6B",marginTop:3}}>{co?.name} · Due {ad.deadline}</div>
                  </div>
                  {co&&<Pill status={co.status}/>}
                </div>
                <div className="fz-metrics">
                  <div className="fz-met"><div className="fz-met-n">{cnt}</div><div className="fz-met-l">Comments</div></div>
                  <div className="fz-met"><div className="fz-met-n" style={{color:"#2B5C8A"}}>{avg}</div><div className="fz-met-l">Avg Stars</div></div>
                  <div className="fz-met"><div className="fz-met-n" style={{color:"#2B5C8A"}}>{(comments[ad.id]||[]).filter(c=>c.wouldBuy).length}</div><div className="fz-met-l">Would Buy</div></div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );

  /* BRANDS */
  const BrandsView = () => {
    if (selectedBrand) {
      const b=companies.find(c=>c.id===selectedBrand.id)||selectedBrand;
      const bads=ADS.filter(a=>a.companyId===b.id);
      return (
        <div className="fs">
          <div style={{display:"flex",alignItems:"center"}}>
            <button className="fz-back" style={{flex:1}} onClick={()=>setSelectedBrand(null)}>← Brands</button>
            {role==="influencer"&&<button style={{padding:"0 20px",minHeight:44,background:"#F7F5F0",border:"none",borderBottom:"1px solid rgba(26,26,26,0.13)",borderLeft:"1px solid rgba(26,26,26,0.13)",cursor:"pointer",fontFamily:"'DM Mono',monospace",fontSize:10,letterSpacing:"0.06em",color:"#2B5C8A"}} onClick={()=>setCModal(b)}>Edit ✎</button>}
          </div>
          <div style={{padding:"20px 20px 16px",background:"#F7F5F0",borderBottom:"1px solid rgba(26,26,26,0.13)"}}>
            <div style={{display:"flex",alignItems:"center",gap:14,marginBottom:14}}>
              <div className="fz-logo" style={{width:52,height:52,fontSize:26}}>{b.logo}</div>
              <div>
                <div style={{fontFamily:"'Cormorant Garamond',serif",fontSize:22,fontWeight:700}}>{b.name}</div>
                <div style={{fontFamily:"'DM Mono',monospace",fontSize:10,letterSpacing:"0.05em",color:"#6B6B6B",marginTop:3}}>{b.industry}</div>
              </div>
              <div style={{marginLeft:"auto"}}><BTag status={b.status}/></div>
            </div>
            <Pill status={b.status}/>
          </div>
          <div className={topClass(b.status)} style={{margin:"16px 20px"}}>
            {[["Relationship",b.relationship],["Deal Value",b.deal||"—"],["Disclosure",b.disclosure||"—"],["Website",b.website||"—"],["Notes",b.notes||"—"]].map(([k,v])=>(
              <div key={k} className="fz-dr"><span className="fz-dk">{k}</span><span className="fz-dv">{v}</span></div>
            ))}
          </div>
          <div className="fz-shd">Ad Campaigns</div>
          {!bads.length?<div style={{padding:20,fontFamily:"'EB Garamond',serif",fontSize:14,color:"#6B6B6B",textAlign:"center"}}>No active campaigns.</div>
            :bads.map(ad=>(
            <div key={ad.id} className="fz-ad-card" style={{margin:"8px 20px"}} onClick={()=>{setSelectedAd(ad);setTab("adroom")}}>
              <div style={{display:"flex",alignItems:"center",gap:12,padding:"14px 16px"}}>
                <span style={{fontSize:22}}>{ad.media}</span>
                <div style={{flex:1}}>
                  <div style={{fontFamily:"'Cormorant Garamond',serif",fontSize:15,fontWeight:700}}>{ad.title}</div>
                  <div style={{fontFamily:"'DM Mono',monospace",fontSize:9,letterSpacing:"0.06em",color:"#6B6B6B",marginTop:3}}>{ad.goal} · Due {ad.deadline}</div>
                </div>
                <div style={{fontFamily:"'DM Mono',monospace",fontSize:9,color:"#2B5C8A",flexShrink:0}}>{(comments[ad.id]||[]).length} notes →</div>
              </div>
            </div>
          ))}
        </div>
      );
    }
    return (
      <div className="fs">
        <div style={{padding:"12px 20px",background:"#F7F5F0",borderBottom:"1px solid rgba(26,26,26,0.13)"}}>
          <div style={{position:"relative"}}>
            <span style={{position:"absolute",left:12,top:"50%",transform:"translateY(-50%)",fontSize:14,color:"#6B6B6B"}}>⌕</span>
            <input className="fz-inp" value={searchQ} onChange={e=>setSearchQ(e.target.value)} placeholder="Search brands or industries…" style={{paddingLeft:32,fontSize:14}}/>
          </div>
        </div>
        <div className="fz-tabs">
          {[{key:"all",label:"All"},{key:"signed",label:"Signed"},{key:"proposed",label:"Proposed"},{key:"no_affiliation",label:"No Affil."},{key:"dont_recommend",label:"Don't Rec."}].map(t=>(
            <button key={t.key} className={`fz-tab${brandFilter===t.key?" active":""}`} onClick={()=>setBrandFilter(t.key)}>
              {t.label}<span className="fz-tab-count">{counts[t.key]}</span>
            </button>
          ))}
        </div>
        <div style={{margin:"16px 20px 80px",display:"flex",flexDirection:"column",gap:1,borderRadius:3,overflow:"hidden",border:"1px solid rgba(26,26,26,0.13)"}}>
          {!filtered.length&&<div style={{padding:"32px 20px",fontFamily:"'EB Garamond',serif",fontSize:15,color:"#6B6B6B",textAlign:"center",background:"#F7F5F0"}}>No brands match.</div>}
          {filtered.map((c,i)=>(
            <div key={c.id} className="fz-row" style={{borderTop:i===0?`3px solid ${STATUS_META[c.status]?.color||"#2B5C8A"}`:undefined}} onClick={()=>setSelectedBrand(c)}>
              <div className="fz-logo">{c.logo}</div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontFamily:"'Cormorant Garamond',serif",fontSize:16,fontWeight:700}}>{c.name}</div>
                <div style={{fontFamily:"'DM Mono',monospace",fontSize:9,letterSpacing:"0.05em",color:"#6B6B6B",marginTop:2}}>{c.industry} · {c.relationship}</div>
              </div>
              <div style={{flexShrink:0,display:"flex",flexDirection:"column",alignItems:"flex-end",gap:4}}>
                <Pill status={c.status}/>
                {c.deal&&<span style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:13,color:STATUS_META[c.status]?.color}}>{c.deal}</span>}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  /* AD ROOM */
  const AdRoomView = () => {
    if (selectedAd) {
      const co=companies.find(c=>c.id===selectedAd.companyId);
      const sorted=getSorted(selectedAd.id);
      const wbc=sorted.filter(c=>c.wouldBuy).length;
      const avg=sorted.length?(sorted.reduce((s,c)=>s+c.stars,0)/sorted.length).toFixed(1):"—";
      return (
        <div className="fs">
          <button className="fz-back" onClick={()=>setSelectedAd(null)}>← Ad Rooms</button>
          <div style={{padding:"18px 20px 16px",background:"#F7F5F0",borderBottom:"1px solid rgba(26,26,26,0.13)"}}>
            <div style={{display:"flex",alignItems:"flex-start",justifyContent:"space-between",marginBottom:10}}>
              <div>
                <div style={{fontFamily:"'Cormorant Garamond',serif",fontSize:19,fontWeight:700,lineHeight:1.2}}>{selectedAd.title}</div>
                <div style={{fontFamily:"'DM Mono',monospace",fontSize:9.5,letterSpacing:"0.05em",color:"#6B6B6B",marginTop:5}}>{co?.name} · {selectedAd.goal} · Due {selectedAd.deadline}</div>
              </div>
              <span style={{fontSize:26,marginLeft:12}}>{selectedAd.media}</span>
            </div>
            {co&&<Pill status={co.status}/>}
          </div>
          <div style={{margin:"16px 20px 0",padding:20,background:"#F7F5F0",border:"1px solid rgba(26,26,26,0.13)",borderRadius:3}}>
            <div style={{fontFamily:"'EB Garamond',serif",fontSize:15,lineHeight:1.65,fontStyle:"italic"}}>"{selectedAd.copy}"</div>
          </div>
          <div style={{margin:"12px 20px 0"}} className="fz-card">
            <div className="fz-metrics">
              <div className="fz-met"><div className="fz-met-n">{sorted.length}</div><div className="fz-met-l">Comments</div></div>
              <div className="fz-met"><div className="fz-met-n" style={{color:"#2B5C8A"}}>{avg}</div><div className="fz-met-l">Avg Stars</div></div>
              <div className="fz-met"><div className="fz-met-n" style={{color:"#2B5C8A"}}>{wbc}</div><div className="fz-met-l">Would Buy</div></div>
            </div>
          </div>
          <div style={{margin:"16px 20px 0",padding:16,background:"#F7F5F0",border:"1px solid rgba(26,26,26,0.13)",borderTop:"3px solid #0A0A0A",borderRadius:3}}>
            <div className="fz-shd" style={{padding:"0 0 10px"}}>Leave Feedback</div>
            <textarea className="fz-textarea" value={draft.text} onChange={e=>setDraft(p=>({...p,text:e.target.value}))} placeholder="Share your honest take on this ad…" rows={3}/>
            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginTop:10}}>
              <div style={{display:"flex",gap:6,alignItems:"center"}}>
                <span style={{fontFamily:"'DM Mono',monospace",fontSize:9,letterSpacing:"0.07em",color:"#6B6B6B",textTransform:"uppercase"}}>Would buy?</span>
                <button className={`fz-btn-t${draft.wouldBuy?" ay":""}`} onClick={()=>setDraft(p=>({...p,wouldBuy:true}))}>Yes</button>
                <button className={`fz-btn-t${!draft.wouldBuy?" an":""}`} onClick={()=>setDraft(p=>({...p,wouldBuy:false}))}>No</button>
              </div>
              <button className="fz-btn-p" onClick={()=>postComment(selectedAd.id)}>Post</button>
            </div>
          </div>
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"16px 20px 8px"}}>
            <div style={{fontFamily:"'DM Mono',monospace",fontSize:9,letterSpacing:"0.1em",textTransform:"uppercase",color:"#6B6B6B"}}>{sorted.length} Friend {sorted.length===1?"Note":"Notes"}</div>
            <div style={{display:"flex",gap:6}}>
              {[["stars","Top Rated"],["newest","Newest"]].map(([k,l])=>(
                <button key={k} className={`fz-btn-s${csort===k?" active":""}`} onClick={()=>setCsort(k)}>{l}</button>
              ))}
            </div>
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:8,padding:"0 20px 20px"}}>
            {sorted.map(cm=>{
              const top=cm.stars===5,has=cm.stars>=3;
              return (
                <div key={cm.id} className={`fz-comment${top?" top-rated":has?" starred":""}`}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8}}>
                    <div>
                      <div style={{fontFamily:"'DM Mono',monospace",fontSize:11,fontWeight:500}}>{cm.friend}</div>
                      <div style={{fontFamily:"'DM Mono',monospace",fontSize:9,color:"#6B6B6B",marginTop:2}}>{cm.time}</div>
                    </div>
                    <span style={{fontFamily:"'DM Mono',monospace",fontSize:9,padding:"3px 8px",borderRadius:2,border:`1px solid ${cm.wouldBuy?"rgba(43,92,138,0.33)":"rgba(139,0,0,0.33)"}`,color:cm.wouldBuy?"#2B5C8A":"#8B0000",background:cm.wouldBuy?"rgba(43,92,138,0.08)":"rgba(139,0,0,0.06)",textTransform:"uppercase",letterSpacing:"0.05em"}}>
                      {cm.wouldBuy?"Would Buy":"Pass"}
                    </span>
                  </div>
                  <div style={{fontFamily:"'EB Garamond',serif",fontSize:15,lineHeight:1.6,marginBottom:12}}>{cm.text}</div>
                  <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                    <Stars count={cm.stars} onRate={s=>rateC(selectedAd.id,cm.id,s)} ro={role!=="influencer"}/>
                    {role==="influencer"&&cm.stars===0&&<span style={{fontFamily:"'DM Mono',monospace",fontSize:9,color:"#6B6B6B",letterSpacing:"0.05em",textTransform:"uppercase"}}>Rate insight</span>}
                    {cm.stars>0&&<span style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:13,color:"#2B5C8A"}}>{cm.stars===5?"Top Insight":cm.stars>=3?"Useful":"Low Signal"}</span>}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      );
    }
    return (
      <div className="fs">
        <div style={{padding:"20px 20px 0"}}>
          <div style={{fontFamily:"'Cormorant Garamond',serif",fontSize:22,fontWeight:700,marginBottom:4}}>Ad Rooms</div>
          <div style={{fontFamily:"'EB Garamond',serif",fontSize:14,color:"#6B6B6B",marginBottom:20}}>View active campaigns. Leave feedback. Rate the insights.</div>
          <div style={{display:"flex",flexDirection:"column",gap:12}}>
            {ADS.map(ad=>{
              const co=companies.find(c=>c.id===ad.companyId);
              const cnt=(comments[ad.id]||[]).length;
              const avg=cnt?((comments[ad.id]||[]).reduce((s,c)=>s+c.stars,0)/cnt).toFixed(1):"—";
              return (
                <div key={ad.id} className="fz-ad-card" onClick={()=>setSelectedAd(ad)}>
                  <div style={{padding:"16px 16px 12px"}}>
                    <div style={{display:"flex",alignItems:"flex-start",gap:10,marginBottom:10}}>
                      <span style={{fontSize:24}}>{ad.media}</span>
                      <div style={{flex:1}}>
                        <div style={{fontFamily:"'Cormorant Garamond',serif",fontSize:16,fontWeight:700}}>{ad.title}</div>
                        <div style={{fontFamily:"'DM Mono',monospace",fontSize:9,letterSpacing:"0.05em",color:"#6B6B6B",marginTop:4}}>{co?.name} · {ad.goal} · Due {ad.deadline}</div>
                      </div>
                      {co&&<Pill status={co.status}/>}
                    </div>
                    <div style={{fontFamily:"'EB Garamond',serif",fontSize:14,color:"#6B6B6B",lineHeight:1.5}}>{ad.copy.length>80?ad.copy.slice(0,80)+"…":ad.copy}</div>
                  </div>
                  <div className="fz-metrics">
                    <div className="fz-met"><div className="fz-met-n">{cnt}</div><div className="fz-met-l">Comments</div></div>
                    <div className="fz-met"><div className="fz-met-n" style={{color:"#2B5C8A"}}>{avg}</div><div className="fz-met-l">Avg Stars</div></div>
                    <div className="fz-met"><div className="fz-met-n" style={{color:"#2B5C8A"}}>{(comments[ad.id]||[]).filter(c=>c.wouldBuy).length}</div><div className="fz-met-l">Would Buy</div></div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  /* FRIENDS */
  const FriendsView = () => (
    <div className="fs">
      <div style={{padding:"20px 20px 14px",background:"#F7F5F0",borderBottom:"1px solid rgba(26,26,26,0.13)"}}>
        <div style={{fontFamily:"'Cormorant Garamond',serif",fontSize:22,fontWeight:700,marginBottom:4}}>Friends</div>
        <div style={{fontFamily:"'EB Garamond',serif",fontSize:14,color:"#6B6B6B"}}>Your trusted circle. Tap any profile to go deeper.</div>
      </div>
      <div style={{padding:"16px 20px",display:"flex",flexDirection:"column",gap:12}}>
        {FRIENDS.map((f,i)=>(
          <div key={f.id} className="fz-fc" onClick={()=>setSelectedFriend(f)} style={{animationDelay:`${i*0.05}s`}}>
            {/* Header */}
            <div style={{display:"flex",alignItems:"center",gap:14,padding:"16px 16px 12px"}}>
              <div className="fz-avatar" style={{width:56,height:56,fontSize:26}}>{f.avatar}</div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{display:"flex",alignItems:"center",gap:4,marginBottom:1}}>
                  <div style={{fontFamily:"'DM Mono',monospace",fontSize:11.5,fontWeight:500}}>{f.handle}</div>
                  {f.verified&&<span className="fz-vbadge">✓</span>}
                </div>
                <div style={{fontFamily:"'Cormorant Garamond',serif",fontSize:15,fontWeight:700}}>{f.name}</div>
                <div style={{fontFamily:"'DM Mono',monospace",fontSize:8.5,letterSpacing:"0.07em",color:"#2B5C8A",textTransform:"uppercase",marginTop:2}}>{f.category}</div>
              </div>
              <div style={{textAlign:"right",flexShrink:0}}>
                <div style={{fontFamily:"'Bebas Neue',sans-serif",fontSize:20,lineHeight:1}}>{f.followers}</div>
                <div style={{fontFamily:"'DM Mono',monospace",fontSize:8,letterSpacing:"0.08em",color:"#6B6B6B",textTransform:"uppercase"}}>followers</div>
              </div>
            </div>
            {/* Bio */}
            <div style={{padding:"0 16px 12px",fontFamily:"'EB Garamond',serif",fontSize:14,color:"#6B6B6B",lineHeight:1.55}}>{f.bio}</div>
            {/* 3-cell mini grid */}
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:2}}>
              {f.grid.slice(0,3).map((e,j)=>(
                <div key={j} style={{aspectRatio:"1",background:"#EFECE5",display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,borderTop:"1px solid rgba(26,26,26,0.13)"}}>{e}</div>
              ))}
            </div>
            {/* Mutual brands */}
            {f.mutualBrands?.length>0&&(
              <div style={{padding:"10px 16px",borderTop:"1px solid rgba(26,26,26,0.13)",display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
                <span style={{fontFamily:"'DM Mono',monospace",fontSize:8.5,letterSpacing:"0.07em",color:"#6B6B6B",textTransform:"uppercase"}}>Mutual:</span>
                {f.mutualBrands.map(b=>{
                  const co=companies.find(c=>c.name===b);
                  return <span key={b} style={{fontFamily:"'DM Mono',monospace",fontSize:9,padding:"2px 8px",background:"rgba(43,92,138,0.08)",border:"1px solid rgba(43,92,138,0.2)",borderRadius:2,color:"#2B5C8A"}}>{co?.logo} {b}</span>;
                })}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );

  const NAV = [
    {key:"home",label:"Home",icon:"⌂"},
    {key:"brands",label:"Brands",icon:"◈"},
    {key:"adroom",label:"Ad Room",icon:"▶"},
    {key:"friends",label:"Friends",icon:"◎"},
  ];

  return (
    <>
      <style>{CSS}</style>
      <div className="fz-app">
        <div className="fz-header">
          <div className="fz-wordmark">Friendsta<span>Zone</span></div>
          <button className="fz-role" onClick={()=>setRole(r=>r==="influencer"?"friend":"influencer")}>
            {role==="influencer"?"● Influencer":"◎ Friend"}
          </button>
        </div>
        <div className="fz-scroll">
          {tab==="home"    && <HomeView/>}
          {tab==="brands"  && <BrandsView/>}
          {tab==="adroom"  && <AdRoomView/>}
          {tab==="friends" && <FriendsView/>}
        </div>
        {tab==="brands"&&!selectedBrand&&role==="influencer"&&(
          <button className="fz-fab" onClick={()=>setCModal("new")} aria-label="Add brand">+</button>
        )}
        <nav className="fz-nav">
          {NAV.map(n=>(
            <button key={n.key} className={`fz-nav-btn${tab===n.key?" active":""}`}
              onClick={()=>{setTab(n.key);if(n.key!=="brands")setSelectedBrand(null);if(n.key!=="adroom")setSelectedAd(null);}}>
              <span className="fz-nav-icon">{n.icon}</span>
              <span className="fz-nav-label">{n.label}</span>
            </button>
          ))}
        </nav>
      </div>
      {cModal&&<CompanyModal company={cModal==="new"?null:cModal} onSave={saveCompany} onDelete={deleteCompany} onClose={()=>setCModal(null)}/>}
      {selectedFriend&&<FriendModal friend={selectedFriend} companies={companies} onClose={()=>setSelectedFriend(null)}/>}
    </>
  );
}
